import { render, staticRenderFns } from "./MInlineDropdown.vue?vue&type=template&id=388bfaea&scoped=true"
import script from "./MInlineDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./MInlineDropdown.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MInlineDropdown.vue?vue&type=style&index=0&id=388bfaea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388bfaea",
  null
  
)

export default component.exports